// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-color: #007bff;
    --secondary-color: #f8f9fa;
    --text-color: #333;
    --status-open: #007bff;
    --status-closed: #28a745;
    --status-not-delivered: #dc3545;
    --status-pending: #ffc107;
}

.dispatcher-container {
    display: flex;
    height: calc(100vh - 145px);
    background-color: var(--secondary-color);
    overflow: hidden; /* Убираем скроллинг */
    z-index: 100;
}

  /* Боковая панель с маршрутами */
  .sidebar {
    width: 330px;
    background: white;
    padding: 20px;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .sidebar h2 {
    font-size: 20px;
    margin-bottom: 10px;
    text-align: center;
  }
  

/* Контейнер для маршрутов с прокруткой */
.routes-list {
    flex-grow: 1;
    overflow-y: auto;
    padding: 0;
    margin-bottom: 10px;
}

.routes-list::-webkit-scrollbar {
    width: 6px;
}

.routes-list::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}

.routes-list li {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    transition: background-color 0.2s ease-in-out;
}

.routes-list li:hover,
.routes-list .active {
    background-color: var(--primary-color);
    color: white;
}

/* Основная часть с деталями маршрута */
.route-details {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
}

.route-details h2 {
    font-size: 22px;
    margin-bottom: 10px;
}

/* Таблица квитанций */
.receipts-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.receipts-table th,
.receipts-table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
}

.receipts-table th {
    background-color: var(--primary-color);
    color: white;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
}

.receipts-table th:hover {
    background: #0056b3;
}

/* Статусы */
.status {
    font-weight: bold;
    padding: 5px;
    border-radius: 5px;
    color: white;
    display: inline-block;
    min-width: 100px;
}

.status.Открыта {
    background-color: blue;
}

.status.закрыта {
    background-color: green;
}

.status.не-доставлено {
    background-color: red;
}

.status.в-обработке {
    background-color: var(--status-pending);
    color: black;
}

/* Заглушка, если маршрут не выбран */
.placeholder-text {
    font-size: 16px;
    color: #888;
    text-align: center;
    margin-top: 50px;
}

/* Настройки колонок */
.sidebar label {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 5px;
}

.sidebar label input {
    margin-right: 5px;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
    .dispatcher-container {
        flex-direction: column;
        height: auto;
    }

    .sidebar {
        width: 95%;
        box-shadow: none;
        padding: 10px;
        background: #fff;
    }

    .routes-list {
        display: flex;
        overflow-x: auto;
        gap: 5px;
        white-space: nowrap;
        padding: 10px 0;
    }

    .routes-list li {
        display: inline-block;
        padding: 10px;
        font-size: 14px;
        border-radius: 5px;
        background: #f1f1f1;
        cursor: pointer;
    }

    .route-details {
        padding: 15px;
    }

    /* Адаптация таблицы под мобильные */
    .receipts-table {
        display: block;
        width: 100%;
        overflow-x: auto;
    }

    .receipts-table thead {
        display: none;
    }

    .receipts-table tbody {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .receipts-table tr {
        display: flex;
        flex-direction: column;
        padding: 10px;
        background: white;
        border: 1px solid #ddd;
        border-radius: 8px;
    }

    .receipts-table td {
        border: none;
        text-align: left;
        padding: 5px 0;
    }

    .receipts-table td:first-child {
        font-weight: bold;
    }
}

.date-filter-row {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
  }
  
  .date-filter-row label {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
  }
  
  .date-filter-row input[type="date"] {
    margin-left: 5px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Developer/ExamplePages/NotDubleExample/ViewRoutes2.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,wCAAwC;IACxC,gBAAgB,EAAE,sBAAsB;IACxC,YAAY;AAChB;;EAEE,gCAAgC;EAChC;IACE,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;;AAGF,yCAAyC;AACzC;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,6CAA6C;AACjD;;AAEA;;IAEI,sCAAsC;IACtC,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,QAAQ;QACR,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA,oCAAoC;IACpC;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,aAAa;QACb,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB","sourcesContent":[":root {\r\n    --primary-color: #007bff;\r\n    --secondary-color: #f8f9fa;\r\n    --text-color: #333;\r\n    --status-open: #007bff;\r\n    --status-closed: #28a745;\r\n    --status-not-delivered: #dc3545;\r\n    --status-pending: #ffc107;\r\n}\r\n\r\n.dispatcher-container {\r\n    display: flex;\r\n    height: calc(100vh - 145px);\r\n    background-color: var(--secondary-color);\r\n    overflow: hidden; /* Убираем скроллинг */\r\n    z-index: 100;\r\n}\r\n\r\n  /* Боковая панель с маршрутами */\r\n  .sidebar {\r\n    width: 330px;\r\n    background: white;\r\n    padding: 20px;\r\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .sidebar h2 {\r\n    font-size: 20px;\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n  }\r\n  \r\n\r\n/* Контейнер для маршрутов с прокруткой */\r\n.routes-list {\r\n    flex-grow: 1;\r\n    overflow-y: auto;\r\n    padding: 0;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.routes-list::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.routes-list::-webkit-scrollbar-thumb {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n    border-radius: 3px;\r\n}\r\n\r\n.routes-list li {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #ddd;\r\n    transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n.routes-list li:hover,\r\n.routes-list .active {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n}\r\n\r\n/* Основная часть с деталями маршрута */\r\n.route-details {\r\n    flex: 1;\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.route-details h2 {\r\n    font-size: 22px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/* Таблица квитанций */\r\n.receipts-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 10px;\r\n    background: white;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.receipts-table th,\r\n.receipts-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.receipts-table th {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    cursor: pointer;\r\n    transition: background 0.2s ease-in-out;\r\n}\r\n\r\n.receipts-table th:hover {\r\n    background: #0056b3;\r\n}\r\n\r\n/* Статусы */\r\n.status {\r\n    font-weight: bold;\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n    color: white;\r\n    display: inline-block;\r\n    min-width: 100px;\r\n}\r\n\r\n.status.Открыта {\r\n    background-color: blue;\r\n}\r\n\r\n.status.закрыта {\r\n    background-color: green;\r\n}\r\n\r\n.status.не-доставлено {\r\n    background-color: red;\r\n}\r\n\r\n.status.в-обработке {\r\n    background-color: var(--status-pending);\r\n    color: black;\r\n}\r\n\r\n/* Заглушка, если маршрут не выбран */\r\n.placeholder-text {\r\n    font-size: 16px;\r\n    color: #888;\r\n    text-align: center;\r\n    margin-top: 50px;\r\n}\r\n\r\n/* Настройки колонок */\r\n.sidebar label {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    padding: 5px;\r\n}\r\n\r\n.sidebar label input {\r\n    margin-right: 5px;\r\n}\r\n\r\n/* Мобильная адаптация */\r\n@media (max-width: 768px) {\r\n    .dispatcher-container {\r\n        flex-direction: column;\r\n        height: auto;\r\n    }\r\n\r\n    .sidebar {\r\n        width: 95%;\r\n        box-shadow: none;\r\n        padding: 10px;\r\n        background: #fff;\r\n    }\r\n\r\n    .routes-list {\r\n        display: flex;\r\n        overflow-x: auto;\r\n        gap: 5px;\r\n        white-space: nowrap;\r\n        padding: 10px 0;\r\n    }\r\n\r\n    .routes-list li {\r\n        display: inline-block;\r\n        padding: 10px;\r\n        font-size: 14px;\r\n        border-radius: 5px;\r\n        background: #f1f1f1;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .route-details {\r\n        padding: 15px;\r\n    }\r\n\r\n    /* Адаптация таблицы под мобильные */\r\n    .receipts-table {\r\n        display: block;\r\n        width: 100%;\r\n        overflow-x: auto;\r\n    }\r\n\r\n    .receipts-table thead {\r\n        display: none;\r\n    }\r\n\r\n    .receipts-table tbody {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n\r\n    .receipts-table tr {\r\n        display: flex;\r\n        flex-direction: column;\r\n        padding: 10px;\r\n        background: white;\r\n        border: 1px solid #ddd;\r\n        border-radius: 8px;\r\n    }\r\n\r\n    .receipts-table td {\r\n        border: none;\r\n        text-align: left;\r\n        padding: 5px 0;\r\n    }\r\n\r\n    .receipts-table td:first-child {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.date-filter-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .date-filter-row label {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    color: #333;\r\n  }\r\n  \r\n  .date-filter-row input[type=\"date\"] {\r\n    margin-left: 5px;\r\n    padding: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
